@if (service.activeTour(); as tour) { @if (service.currentStep(); as step) {
<div class="tour-backdrop" aria-hidden="true"></div>

@if (highlight(); as box) {
<div
  class="tour-highlight"
  [style.top]="box.top"
  [style.left]="box.left"
  [style.width]="box.width"
  [style.height]="box.height"
  aria-hidden="true"
></div>
}

<div
  class="tour-card"
  role="dialog"
  aria-modal="false"
  [attr.aria-labelledby]="'tour-title'"
  [attr.aria-describedby]="'tour-body'"
  [style.top]="cardStyle().top"
  [style.left]="cardStyle().left"
  tabindex="-1"
>
  <div class="flex items-start justify-between gap-2 mb-2">
    <h2 id="tour-title" class="text-base font-semibold m-0">
      {{ step.titleKey | transloco }}
    </h2>
    <button
      type="button"
      class="tour-close"
      (click)="service.stop()"
      [attr.aria-label]="'tour.close' | transloco"
    >
      <ksg-icon name="pi-times" [size]="18" />
    </button>
  </div>

  @if (service.sandboxActive() && step.simulatesSave) {
  <p class="tour-sim-note">{{ 'tour.simulationOnly' | transloco }}</p>
  }

  <p id="tour-body" class="text-sm m-0 mb-3">{{ step.bodyKey | transloco }}</p>

  <div class="flex items-center justify-between gap-2">
    <span class="text-xs text-500" aria-live="polite">
      {{ service.stepIndex() + 1 }} / {{ service.totalSteps() }}
    </span>
    <div class="flex gap-2">
      @if (!service.isFirst()) {
      <ksg-button variant="text" size="sm" (click)="service.prev()"
        >{{ 'tour.prev' | transloco }}</ksg-button
      >
      } @if (service.isLast()) {
      <ksg-button size="sm" (click)="service.next()"
        >{{ 'tour.finish' | transloco }}</ksg-button
      >
      } @else {
      <ksg-button size="sm" (click)="service.next()"
        >{{ 'tour.next' | transloco }}</ksg-button
      >
      }
    </div>
  </div>
</div>
} }
